var map = {
	"./common/empty.png": 36990,
	"./common/frame-corner-bottom-left.png": 90372,
	"./common/frame-corner-bottom-right.png": 29665,
	"./common/frame-corner-top-left.png": 98712,
	"./common/frame-corner-top-right.png": 10861,
	"./common/gift.png": 53731,
	"./common/hot.gif": 66187,
	"./event/top-bg.png": 63815,
	"./event/top-right.png": 97558,
	"./event/top-shell-bg.png": 35408,
	"./footer/border-body.png": 62076,
	"./footer/border-top.png": 39679,
	"./header/dropdown-arrow.png": 28218,
	"./header/menu-toggle.png": 12803,
	"./header/mobile-arrow.png": 15023,
	"./home/banner-bg.png": 99957,
	"./home/category-favorite.webp": 48559,
	"./home/category-hot-active.png": 8202,
	"./home/category-hot.png": 89065,
	"./home/category-popular.webp": 70204,
	"./home/category-recent-active.png": 39676,
	"./home/category-recent.png": 54679,
	"./home/category-recent.webp": 25588,
	"./home/category-slots.webp": 40112,
	"./home/event-card-corner-bottom-left.png": 27914,
	"./home/event-card-corner-bottom-right.png": 52487,
	"./home/event-card-corner-top-left.png": 40610,
	"./home/event-card-corner-top-right.png": 32031,
	"./home/frame-corner-bottom-left.png": 59046,
	"./home/frame-corner-bottom-right.png": 37243,
	"./home/frame-corner-top-left.png": 45278,
	"./home/frame-corner-top-right.png": 15795,
	"./home/game-section-header-bg.png": 79577,
	"./home/jackpot-bg.png": 53137,
	"./home/notice-icon.webp": 11910,
	"./home/page-bg.png": 77060,
	"./home/redeem-code-icon.png": 8443,
	"./home/search-active.png": 56148,
	"./home/search.png": 80319,
	"./login/exit-confirm-bg.png": 99028,
	"./login/popup-bg.png": 61147,
	"./notification/bg-top1.png": 33295,
	"./person/avatar.png": 43766,
	"./person/bg-vip.png": 88094,
	"./person/bg-vipBottom.png": 49411,
	"./person/bg-vipPc.png": 36461,
	"./person/icon-Deposit.png": 25303,
	"./person/icon-DepositVip.png": 74414,
	"./person/icon-History.png": 25445,
	"./person/icon-Install.png": 71368,
	"./person/icon-Notification.png": 28120,
	"./person/icon-Senha.png": 1374,
	"./person/icon-Transaction.png": 64537,
	"./person/icon-Withdraw.png": 95003,
	"./person/icon-arrow.png": 99454,
	"./person/icon-betsVip.png": 38176,
	"./person/icon-exchange.png": 29914,
	"./person/icon-service.png": 58984,
	"./person/icon_Wallet.png": 60576,
	"./person/icon_copy.png": 26520,
	"./person/icon_logout.png": 64109,
	"./person/icon_notification.png": 31042,
	"./person/vip-center-bg.png": 15082,
	"./share/TreasureChest.png": 67921,
	"./share/TreasureLock.png": 95797,
	"./share/TreasureUnLock.png": 9996,
	"./share/bg-shareMoney.png": 59454,
	"./share/bg-sharePeople.png": 20665,
	"./share/bg-top.png": 89712,
	"./share/facebook.png": 83019,
	"./share/icon_fackbook.png": 62423,
	"./share/icon_howShare.png": 23034,
	"./share/icon_ins.png": 81409,
	"./share/icon_inviteDate.png": 19754,
	"./share/icon_telegram.png": 15600,
	"./share/icon_tiktok.png": 37047,
	"./share/icon_whatsapp.png": 23455,
	"./share/icon_x.png": 1029,
	"./share/icon_youtube.png": 20170,
	"./share/invite_banner1.png": 32854,
	"./share/invite_banner2.png": 23533,
	"./share/invite_banner3.png": 97380,
	"./share/invite_banner4.png": 7323,
	"./share/proxy.png": 3159,
	"./share/redemption-code-title.png": 87005,
	"./share/share_bg.png": 51442,
	"./share/trumpet.png": 38212,
	"./sidebar/affiliate-active.png": 39808,
	"./sidebar/affiliate.png": 83555,
	"./sidebar/copy.png": 36147,
	"./sidebar/customer-service.png": 31570,
	"./sidebar/hot-bg.png": 96611,
	"./sidebar/invite-free.png": 17360,
	"./sidebar/language-arrow.png": 30418,
	"./sidebar/menu-item-border.png": 88462,
	"./sidebar/path-arrow.png": 89185,
	"./sidebar/promotion-active.png": 40722,
	"./sidebar/promotion.png": 46337,
	"./sidebar/redemption-code-active.png": 36638,
	"./sidebar/redemption-code.png": 7605,
	"./sidebar/refresh.png": 87267,
	"./sidebar/share-panel-bg.png": 88436,
	"./sidebar/sidebar-border.png": 1291,
	"./sidebar/social-media-active.png": 48083,
	"./sidebar/social-media.png": 78366,
	"./sidebar/telegram.gif": 90042,
	"./sidebar/vip-active.png": 8628,
	"./sidebar/vip-badge.png": 73661,
	"./sidebar/vip.png": 69919,
	"./signIn/suo.png": 30567,
	"./signIn/vipicon.png": 89598,
	"./signIn/vipiconact.png": 61620,
	"./tabbar/active-corner-bottom-left.png": 21056,
	"./tabbar/active-corner-bottom-right.png": 42229,
	"./tabbar/active-corner-top-left.png": 57316,
	"./tabbar/active-corner-top-right.png": 57345,
	"./tabbar/affiliate-active.png": 52148,
	"./tabbar/affiliate.png": 45823,
	"./tabbar/home-active.png": 22474,
	"./tabbar/home.png": 18409,
	"./tabbar/menu-active.png": 5158,
	"./tabbar/menu.png": 29805,
	"./tabbar/profile-active.png": 7834,
	"./tabbar/profile.png": 53625,
	"./tabbar/sport.png": 20172,
	"./tabbar/vip-active.png": 15864,
	"./tabbar/vip.png": 67691
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 84500;